import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import View from "./view/View";
import Input from "./input/Input";
import OXPopup from "../../../learning/presentational/popup/OXPopup";
import AnsweringCompleteToast from "../toast/AnsweringCompleteToast";
import LoadingPopup from "../../../learning/presentational/popup/LoadingPopup";
import clsx from "clsx";

const Body = ( props ) => {

  const loading = useSelector( state => state.loading );
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const {
    Viewer,
    Inputer,
    OXPopupHider,
    Jumper,
    children,
    ...PROPS
  } = props;

  return (
    <div className="container">
      <div className="inner">
        <div
          className={
            clsx(
              "learningBox",
              (answeringQuestions.data.objctYn === 'Y') && 'multiple'
            )
          }
        >
          <Viewer><View { ...PROPS } /></Viewer>
          <Inputer><Input { ...PROPS } /></Inputer>
        </div>
        { answeringQuestions.isShowOXPopup && <OXPopupHider><OXPopup /></OXPopupHider> }
        { answeringQuestions.resultData.prgsCd && <Jumper><AnsweringCompleteToast /></Jumper> }
        { loading.isShowBall && <LoadingPopup /> }
      </div>
    </div>
  );

};

Body.defaultProps = {
  Viewer : Fragment,
  Inputer : Fragment,
  OXPopupHider : Fragment,
  Jumper : Fragment
};

export default Body;
